import { useEffect, useMemo } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useLang } from "contexts/lang-context";
import { contentAlternates, isNoindexPath, languageUrls } from "lib/seo";

const Hreflang = ({ data }: { data: any }) => {
  const router = useRouter();
  const { setUrls } = useLang();
  const links = useMemo(() => contentAlternates(data, {
    asPath: router.asPath,
    pathname: router.pathname,
    locales: router.locales ? [...router.locales] : undefined,
  }), [data, router.asPath, router.pathname, router.locales]);

  useEffect(() => {
    setUrls(languageUrls(links));
  }, [links, setUrls]);

  return (
    <Head>
      {!isNoindexPath(router.asPath) && links.map(({ hrefLang, href }) => (
        <link key={`alternate-${hrefLang}`} rel="alternate" hrefLang={hrefLang} href={href} />
      ))}
    </Head>
  );
};

export default Hreflang;
